module.exports = __webpack_public_path__ + "Participant Email Template.pdf";